export default "__VITE_ASSET__439363f2__"